import styled from 'styled-components';
import { HashLink as anchorLink } from 'react-router-hash-link';

import {
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
  fontFamilyPrimary,
  colorBlack900,
  colorWhite2,
  colorGrey400,
} from 'styles';
import { H2, Paragraph, ParagraphSmall } from 'components/Typography';

export const Wrapper = styled.section`
  width: 100%;
  padding: 16px;
  background: #ffffff;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.16);
  border-radius: 2px;

  @media all and ${mediaQueryMobileLargeMin} {
    padding: 24px;
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  & button {
    margin-top: 16px;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;

    & button {
      margin-top: 0;
    }
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

export const Update = styled(ParagraphSmall)`
  display: flex;
  align-items: center;
  line-height: 16px;
  margin-bottom: 8px;
`;

export const PrimaryTitle = styled(H2)`
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  line-height: 24px;
  margin-bottom: 0;

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 20px;
    line-height: 28px;
    margin-bottom: 8px;
  }
`;

export const SubTitle = styled.h1`
  font-family: ${fontFamilySecondary};
  font-size: 14px;
  line-height: 24px;
  color: ${colorGrey400};
  font-weight: 700;
`;

export const Text = styled.p`
  font-family: ${fontFamilyPrimary};
  font-size: 13px;
  line-height: 20px;
  color: ${colorBlack900};
  margin-top: 16px;
  margin-bottom: -19px;

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 14px;
    line-height: 24px;
  }
`;
export const HashLink = styled(anchorLink)`
  color: ${colorWhite2};
  font-size: 14px;
  line-height: 24px;
  margin-left: 0;
  margin-right: 0;
`;

export const Source = styled(Paragraph)`
  color: ${colorGrey400};
  line-height: 16px;
`;
